import config from '../../config';

export function loginToVK() {
  return new Promise((res) => {
    window.passFBAuthCode = (code, _window) => {
      _window.close();
      res(code);
    };
    const url = `https://oauth.vk.com/authorize?client_id=${config.vkId}&redirect_uri=${window.location.origin}&response_type=code&v=5.60`;
    window.open(url, '_blank');
  });
}



/** WEBPACK FOOTER **
 ** ./src/logic/auth/vk.js
 **/